import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Tabs = styled.div`
  margin-top: 10px;
  color: #18191a;
  display: inline-block;
  padding: 10px;
  border-radius: 10px 10px 0 0;
  cursor: pointer;
  font-size: 16px;
  width: 100%;

  .tab {
    margin-top: 10px;
    color: #18191a;
    display: inline;
    justify-content: space-between;
    padding: 10px;
    border-radius: 10px 10px 0 0;
    cursor: pointer;
    font-size: 16px;
    font-weight: 400;
  }

  .active {
    background: none;
    border-bottom: 3px solid #043c10;
    color: #549a9a;
  }

  .content {
    margin-top: 30px;
  }
`;

export const Navigation = (props) => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (props.active) {
      setActive(props.active);
    }
  }, [props]);

  const select = (i) => {
    return function () {
      setActive(i);
    };
  };

  const renderTabs = () => {
    return React.Children.map(props.children, (item, i) => {
      if (i % 2 === 0) {
        let act = active === i ? 'active' : '';
        return (
          <a onClick={select(i)} className={`${act} tab`}>
            {item}
          </a>
        );
      }
    });
  };

  const renderContent = () => {
    return React.Children.map(props.children, (item, i) => {
      if (i - 1 === active) {
        return <div className="content">{item}</div>;
      } else {
        return;
      }
    });
  };
  return (
    <Tabs>
      {renderTabs()}
      {renderContent()}
    </Tabs>
  );
};

Navigation.propTypes = {
  children: PropTypes.node.isRequired,
  active: PropTypes.number.isRequired,
};
